import { Row, Col } from "react-bootstrap";
import StoreIcon from "@mui/icons-material/Store";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import "./businessprofiletitle.css";
const Businessprofiletitle = ({ name, linkurl, id, designurl }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCreateRestaurantProfile = location.pathname.startsWith(
    "/CreateRestaurantProfile"
  );
  const targetVisitShopUrl = isCreateRestaurantProfile && designurl
    ? `${designurl.replace(/\/$/, "")}/${id}`
    : `${linkurl?.replace(/\/$/, "")}/${id}`;

  return (

    <div className="business-profile-title-wrap p-4">
      <Row className="business-profile-title-card ps-2 pe-2 p-3 rounded pt-2 pb-2 bg-white" style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.3)" }}>
        <Col lg="4" xl="4" md="5" xs="12" sm="4" className="business-profile-title-name mt-2 businessprofile_name">
          <h4 className="mb-0">BusinessProfile</h4>
          <p className="font_small font-grey "><b>{name}</b></p>
        </Col>
        <Col
          lg="8"
          sm="8"
          xs="12"
          md="7"
          className="business-profile-primary-actions d-flex justify-content-end gap-2"
        >
          <div className="business-profile-action-item">
            <button
              onClick={() => navigate("/BuyingSide")}
              className=" d-md-block  btn text-white  font-sm  b-radius mt-2  ps-2 pe-2" style={{ backgroundColor: "#0353a4" }}
            >
              Connect to Business
            </button>
          </div>
          <div className="business-profile-action-item">
            <button
              onClick={() => navigate(`/connection-request/${id}`)}
              className="btn text-white  font-sm  b-radius mt-2 ps-2 pe-2 " style={{ backgroundColor: "#0353a4" }}
            >
              Connection Requests
            </button>
          </div>
          <div className="business-profile-action-item">
            <button
              className="btn text-white  font-sm b  b-radius mt-2  ps-2 pe-2 pb-1"
              onClick={() => navigate(targetVisitShopUrl)}
              style={{ backgroundColor: "#0353a4" }}
            >
              &nbsp; &nbsp;
              <StoreIcon className="icon_f" />
              &nbsp;
              <span>
                {location.pathname === `/company-business-Profile/${id}` ||
                  location.pathname === `/service-business-profile/${id}`
                  ? "Visit Profile"
                  : "Visit Shop"}
              </span>
              &nbsp; &nbsp;
            </button>
          </div>
        </Col>

        <Col lg="12" sm="12" xs="12" className="business-profile-secondary-action-column text-end pt-0 mt-1">
          <div className="business-profile-secondary-actions d-flex justify-content-end gap-2 ">
            <button
              className=" bussines_connect btn text-white  font-sm  b-radius font_11  ps-4 pe-4 pb-2 pt-2"
              onClick={() => navigate("/invest-form")} style={{ backgroundColor: "#0353a4" }}
            >
              Invest with selectezi
            </button>

            <button
              className=" bussines_connect btn text-white  font-sm  b-radius font_11  ps-4 pe-4 pt-2 pb-2"
              onClick={() => navigate("/seekar-profile")} style={{ backgroundColor: "#0353a4" }}
            >
              Investment seeker profile
            </button>
          </div>
        </Col>
      </Row>

    </div>
  );
};
export default Businessprofiletitle;
